import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Paper, Button } from "@mui/material";
import "./CadastroPage.css";
import styles from "../../../styles/styles";
import CadastroHeader from "../../../components/CadastroHeader/CadastroHeader";
import useUsuarios from "../../../app/hooks/useUsuario";
import useTrem from "../../../app/hooks/useTrem";
import usePerfis from "../../../app/hooks/usePerfis";
import ActiveTab from "./ActiveTab";
import { rotas } from "../../../app/configs/CadastroConfigs";
import { usePermissao } from "../../../app/hooks/UsePermissao";
import SemPermissao from "../../../components/SemPermissao/SemPermissao";

export default function CadastroPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [tab, setTab] = useState(location.state?.activeTab || "usuario");
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [itensPorPagina] = useState(20);
  const { temPermissao } = usePermissao();

  const {
    usuarios,
    totalCount: usuariosTotal,
    listarUsuarios,
    excluirUsuario,
    ModalComponent: ModalComponentUsuarios,
  } = useUsuarios();

  const {
    perfis,
    totalCount: perfisTotal,
    listarPerfis,
    excluirPerfil,
    ModalComponent: ModalComponentPerfis,
  } = usePerfis();

  const {
    trens,
    totalCount: trensTotal,
    listarTrens,
    excluirTrem,
    ModalComponent: ModalComponentTrem,
  } = useTrem();

  const abas = [
    { nome: "usuario", label: "Usuário", permissao: "Geral.VerDadosCadastro" },
    { nome: "trem", label: "Trem", permissao: "Geral.VerDadosCadastro" },
  ];

  const abasVisiveis = abas.filter((aba) => temPermissao(aba.permissao));

  useEffect(() => {
    const abaAtualValida = abasVisiveis.find((a) => a.nome === tab);
    if (!abaAtualValida && abasVisiveis.length > 0) {
      setTab(abasVisiveis[0].nome);
    }
  }, [abasVisiveis, tab]);

  useEffect(() => {
    if (!temPermissao("Geral.VerDadosCadastro")) return;

    if (tab === "usuario") {
      listarUsuarios(paginaAtual, itensPorPagina);
    }  else if(tab === "trem") {
      listarTrens(paginaAtual, itensPorPagina);
    }
  }, [tab, paginaAtual]);

  useEffect(() => {
    if (paginaAtual !== 1) {
      setPaginaAtual(1);
    }
  }, [tab]);

  const handleNavigate = (tabName, item = null) => {
    const path = rotas[tabName];
    if (!path) return;

    if (tabName === "usuario" && item) {
      const usuarioComPerfil = {
        ...item,
        perfilId: item.perfilId || "",
        perfilNome: item.perfilNome || "—",
      };
      navigate(path, { state: { ...usuarioComPerfil, activeTab: tabName } });
    } else if (item) {
      navigate(path, { state: { ...item, activeTab: tabName } });
    } else {
      navigate(path, { state: { activeTab: tabName } });
    }
  };

  const handleCreate = (tabName) => {
    const path = rotas[tabName];
    if (!path) return;
    navigate(path, { state: { activeTab: tabName } });
  };

  const renderForm = () => {
    if (!temPermissao("Geral.VerDadosCadastro")) {
      return <SemPermissao />;
    }

    if (tab === "usuario") {
      return (
        <ActiveTab
          title="Usuários cadastrados"
          datas={usuarios}
          tab="usuario"
          totalItens={usuariosTotal}
          paginaAtual={paginaAtual}
          setPaginaAtual={setPaginaAtual}
          itensPorPagina={itensPorPagina}
          onEdit={handleNavigate}
          onDelete={excluirUsuario}
        />
      );
    }

    if (tab === "trem") {
      return (
        <ActiveTab
          title="Trens cadastrados"
          datas={trens}
          totalItens={trensTotal}
          paginaAtual={paginaAtual}
          setPaginaAtual={setPaginaAtual}
          itensPorPagina={itensPorPagina}
          tab="trem"
          onEdit={handleNavigate}
          onDelete={excluirTrem}
        />
      );
    }

    return null;
  };
  const podeCadastrar = temPermissao("Geral.VerDadosCadastro");
  if (!podeCadastrar) {
    return (
      <Box sx={styles.pageWrapper}>
        <Box component="main" sx={styles.mainContent}>
          <Paper elevation={0} sx={styles.card}>
            <CadastroHeader title="Cadastros" />
            <SemPermissao />
          </Paper>
        </Box>
      </Box>
    );
  }



  return (
    <Box sx={styles.pageWrapper}>
      <Box component="main" sx={styles.mainContent}>
        <Paper elevation={0} sx={styles.card}>
          <CadastroHeader
            title="Cadastros"
            handle={podeCadastrar ? () => handleCreate(tab) : undefined}
          />

          <div className="tabs">
            {abasVisiveis.map((aba) => (
              <Button
                key={aba.nome}
                className={`tab ${tab === aba.nome ? "active" : ""}`}
                onClick={() => setTab(aba.nome)}
              >
                {aba.label}
              </Button>
            ))}
          </div>

          <div className="card-container">
            <div className="card-cadastro">{renderForm()}</div>
          </div>

          {ModalComponentUsuarios}
          {ModalComponentPerfis}
          {ModalComponentTrem}
        </Paper>
      </Box>
    </Box>
  );
}
